// extracted by mini-css-extract-plugin
export default {"board":"Board_board__waieH","flashing":"Board_flashing__zdUNt","flash":"Board_flash__bvglk","flash-animation":"Board_flash-animation__qrE9Q"};